import { z } from 'zod'

import { Building } from '@/reducers/types'

export const PlacePmsTypeSchema = z.enum(['yardi', 'entrata', 'realPage', 'rentManager', 'resman'])

export const PlacePmsType = PlacePmsTypeSchema.enum

export type PlacePmsType = z.infer<typeof PlacePmsTypeSchema>

export const PMS_NONE = 'none' as const

// Note: the same priority the legacy page used to decide which PMS a building is connected to
export const getBuildingPms = (building: Building | null | undefined): PlacePmsType | null => {
  if (!building) return null

  return (
    PlacePmsTypeSchema.options.find(
      (type) => building[`${type}PropertyId`] || building[`${type}ManagementId`],
    ) ?? null
  )
}

// Note: vendor names are not translated
export const PMS_LABELS: Record<PlacePmsType, string> = {
  entrata: 'Entrata',
  realPage: 'RealPage',
  rentManager: 'Rent Manager',
  resman: 'ResMan',
  yardi: 'Yardi',
}
